<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <h1 class="text-center title">Astuces</h1>
    <div class="page-containerp">
      <div class="page-area-new">
        <h2 class="mt-3">Commencer le jeu de la page d’accueil</h2>

        <img class="img-fluid" src="@/assets/astuces/accueil.png" alt="" />

        <p>Pour commencer le jeu, tu dois visionner la vidéo d’introduction afin d’en apprendre davantage sur le fonctionnement du jeu. À la suite du visionnement, le bouton <strong>COMMENCER</strong> apparaîtra.</p>

        <img class="img-fluid" src="@/assets/astuces/accueil-continuer.png" alt="" />

        <h2>Créer un compte pour accéder au jeu sérieux</h2>
        <p>Afin de sauvegarder ta progression, crée-toi d’abord un compte gratuit. Pour ce faire, clique sur le lien hypertexte «&nbsp;crée-toi un compte<strong>&nbsp;»</strong> qui se trouve dans la barre de menu.</p>

        <img class="img-fluid" src="@/assets/astuces/creation-compte.png" alt="" />

        <p>Tu accèdes alors à la page suivante.</p>

        <img class="img-fluid" src="@/assets/astuces/formulaire-creation-compte.png" alt="" />

        <p>Tape l’information qui t’est demandée (p. ex., prénom, nom de famille, courriel), choisis un mot de passe et clique sur le bouton <strong>S’inscrire</strong>.</p>
        <p>Lorsque ton compte a été créé avec succès, tu vois le message «&nbsp;Clique sur le bouton <strong>Continuer</strong>&nbsp;»</p>

        <h2>Quitter le jeu sérieux</h2>
        <p>Pour quitter le jeu sérieux et sauvegarder ta progression, tu dois terminer une mise en situation. Si tu quittes le jeu, assure-toi, à ton retour, d’entrer ton courriel et ton mot de passe à l’aide du bouton <strong>Se connecter </strong>avant de continuer. Selon les paramètres de ton fureteur (le logiciel que tu utilises pour explorer Internet), ton courriel et ton mot de passe pourraient déjà y être sauvegardés.</p>
        <p><strong>Rappel&nbsp;important&nbsp;:</strong> Si tu termines des mises en situation sans être connectée ou connecté, tu ne peux sauvegarder ni ta progression ni tes notes dans ton bloc-notes!</p>

        <h2>Utiliser l’outil bloc-notes</h2>
        <p>L’outil bloc-notes te permet de prendre des notes en parcourant le jeu sérieux. Tu peux y accéder à tout moment, en cliquant sur l’icône suivante.</p>

        <img class="img-fluid" src="@/assets/astuces/blocnotes-boutton.png" alt="" />

        <p>Des marque-pages se trouvent dans chacune des mises en situation. Les notes insérées dans la boîte de texte se sauvegardent automatiquement.</p>

        <img class="img-fluid" src="@/assets/astuces/bloc-note.png" alt="" />

        <h2>Chercher des éléments du jeu</h2>
        <p>Pour chercher des éléments du jeu sérieux, rends-toi à la table des matières. Tu peux la trouver à l’aide de la barre de navigation.</p>

        <img class="img-fluid" src="@/assets/astuces/table-des-matieres-lien.png" alt="" />

        <p>Ici, tu trouveras tous les éléments de chacune des mises en situation pour chaque environnement qui se trouve sur la carte interactive.</p>

        <img class="img-fluid" src="@/assets/astuces/table-des-matieres.png" alt="" />

        <h2>Animer une communauté d’apprentissage à l’aide du jeu sérieux</h2>
        <p>Le jeu sérieux comprend des fiches d’animation comme appui à l’animation des communautés d’apprentissage. Celles-ci comprennent de bonnes pratiques ainsi que des questions de réflexion pour améliorer continuellement le parcours professionnel du personnel éducateur dans le domaine de la petite enfance. Chaque fiche est liée aux mises en situation qui se trouvent dans le jeu sérieux. Pour y accéder, clique sur <strong>Menu</strong>.</p>

        <img class="img-fluid" src="@/assets/astuces/fiche-lien.png" alt="" />

        <h2>Aller plus loin</h2>
        <p>Pour le personnel éducateur qui désire aller plus loin, le jeu sérieux comprend des ressources supplémentaires relatives au domaine de la petite enfance et à divers sujets ciblés. Chacune des thématiques comporte un résumé des concepts du sujet, des questions de réflexion, des défis en lien avec le sujet ciblé ainsi que des informations supplémentaires sur le sujet. Chaque thématique est liée aux mises en situation qui se trouvent dans le jeu sérieux. Pour y accéder, clique sur <strong>Menu</strong>.</p>

        <img class="img-fluid" src="@/assets/astuces/ressouces-lien.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
export default {
  components: {
    ProgressBars,
  },
};
</script>

<style scoped>
h1.title {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: "Poppins";
  color: #333;
}
h2 {
  font-size: 1.35rem !important;
  color: #000;
  font-weight: 600;

  margin-top: 50px;
  margin-bottom: 15px;
}
.page-container {
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.page-area-new {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px 30px;
  margin-bottom: 20px;
}
img {
  max-width: 800px;
  margin-bottom: 20px;
}
</style>
